var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("iframe", {
        staticClass: "iframe",
        attrs: {
          src: "http://t.ymt.com/1yr733k?code=HynT90wQkDpbXOPRscBQ1ZL1tmSBdG27f9P8pLWSZkEWqM3Pc9RyKbYDhOGs&client_id=10009",
          frameborder: "0",
        },
      }),
      _c("main-title", {
        attrs: { arrowClick: true },
        scopedSlots: _vm._u([
          {
            key: "rightBtn",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ]),
      }),
      _c("hright-side"),
      _c("lengend-bar"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }